<app-layout>
  <div *ngIf="talep">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">
              Talep Bilgileri
            </h3>
          </div>
          <div class="card-body">
            <app-talep-detay [source]="talep"></app-talep-detay>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Sipariş Kalemleri</h3>
          </div>
          <div class="table-responsive">
            <table class="table card-table table-vcenter text-nowrap datatable">
              <thead>
                <tr>
                  <th class="w-1">Stok Kodu</th>
                  <th>Stok Adı</th>
                  <th>Ölçü Birimi</th>
                  <th>Talep Edilen Miktarss</th>
                  <th *ngFor="let t of teklifCariler">
                    <a href="#/cari?id={{t.teklif.cari?.id}}" target="_blank">{{t.teklif.cari?.firmaUnvani}}</a>
                    ({{t.teklif.teslimSekli?.aciklama}})
                    ({{t.teklif.cari?.vadeGunu}})
                    <br>
                    <a href="#/teklif?id={{t.teklif.id}}" target="_blank" class="btn btn-sm btn-warning">Teklif Detay</a>
                    <!-- <button class="btn btn-warning btn-sm" (click)="teklifDetay(t.teklif.id)">Teklif Detay</button> -->
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of talep.talepKalemler;let i=index;">
                  <td><span class="text-muted">{{t.stokKodu}}</span></td>
                  <td>{{t.stokAdi}}</td>
                  <td>{{t.olcuBirimi}}</td>
                  <!-- <td>{{t.talepEdilen - t.toplamSiparisMiktar}}</td> -->
                  <td>{{t.talepEdilen}}</td>
                  <td *ngFor="let x of teklifler;let j=index">
                    <div *ngFor="let y of x.teklifKalemler">
                      <div *ngIf="y.talepKalemId==t.id">{{y.tutar}} {{y.paraBirimi?.aciklama}}
                        <label class="form-check">
                          <input class="form-check-input" type="checkbox" [(ngModel)]="y.checked"
                            (change)="teklifKalemSec($event, y, t, x.cari.id)">
                          <span class="form-check-label">Seç</span>
                        </label>

                        <input class="form-control" type="number" [(ngModel)]="y.siparisMiktar"
                          (change)="teklifKalemSec($event, y, t, x.cari.id)" min="1" max="{{t.talepEdilen}}">
                      </div>
                    </div>
                    <ng-template #elseBlock>Teklif Yok</ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right">
            <b>Sipariş Toplamı:</b> {{totalTutarText}}
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card p-0">
          <div class="card-header">
            <h3 class="card-title">Onay</h3>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <div class="form-label">Sipariş Notu</div>
              <textarea class="form-control" name="example-textarea-input" rows="3" placeholder="Sipariş Notu"
                [(ngModel)]="siparisNotu"></textarea>
            </div>
          </div>
          <div class="card-footer text-right">
            <button class="btn btn-success" (click)="save()" [disabled]="siparisOlusturDisabled">Sipariş Oluştur</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>